import { PeakEventsGetRequestParams } from "@lib/core";

export interface PeakEventDefaultParams extends PeakEventsGetRequestParams { }
export class PeakEventDefaultParams {
  constructor() {
    this.select = "*";
    this.order = "id.asc";
  }
}